// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumb":"Breadcrumb--1lbWv"};